import { createApi } from "@reduxjs/toolkit/query/react";

import { createAuthBaseQuery } from "../../common/utils";
import { HOSTNAME } from "../../constant/host";
import type { PublicCreatorProfileResponse } from "../../types/profile";

/**
 * クリエイター公開プロフィール（slug アクセス）取得用 API スライス。
 *
 * BE `GET /api/creators/<vanity_slug>`（`permission_classes=[AllowAny]`）は
 * 未ログインでも閲覧できる。`createAuthBaseQuery` は auth_token が cookie に
 * あるときだけ `Authorization` を付与するため、ログイン中の閲覧者には
 * `is_following` をサーバ側で算出させつつ、未ログインでもそのまま動作する。
 */
export const publicCreatorsApi = createApi({
  reducerPath: "publicCreatorsApi",
  baseQuery: createAuthBaseQuery(HOSTNAME),
  tagTypes: ["PublicCreator"],
  endpoints: (builder) => ({
    // slug でクリエイター公開プロフィールを取得
    getPublicCreator: builder.query<PublicCreatorProfileResponse, string>({
      query: (vanitySlug) => `/api/creators/${encodeURIComponent(vanitySlug)}`,
      providesTags: (_result, _error, vanitySlug) => [
        { type: "PublicCreator", id: vanitySlug },
      ],
    }),
    // サイトトップ（soremo.jp/）用ランディングプロフィールを取得。
    // BE が settings.ARTIST_MAIL_LANDINGPAGE のアカウントを解決し、
    // getPublicCreator と同形のレスポンスを返す。未設定時は 404。
    getLandingCreator: builder.query<PublicCreatorProfileResponse, void>({
      query: () => "/api/landing-profile",
      providesTags: [{ type: "PublicCreator", id: "__landing__" }],
    }),
  }),
});

export const { useGetPublicCreatorQuery, useGetLandingCreatorQuery } =
  publicCreatorsApi;
